import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from "@angular/core";
import { ButtonDirective } from "primeng/button";

// Floating bar for a list's row selection: count and Select All / Clear
// selection on the left, the list's batch actions projected on the right.
// Renders nothing while no row is selected. Place it as a direct child of the
// list's .card-box, after the table: it sticks to the bottom of the viewport
// while the list scrolls, and a sticky element cannot leave its parent's box.
@Component({
  selector: "app-table-selection-bar",
  templateUrl: "./table-selection-bar.component.html",
  styleUrls: ["./table-selection-bar.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective],
})
export class TableSelectionBarComponent {
  public readonly selectedCount = input(0);
  public readonly totalCount = input(0);

  public readonly selectAll = output<void>();
  public readonly clearSelection = output<void>();

  // Select All: adds the current page to the selection and keeps the rows
  // picked on other pages. Rows match by `id`, the table's default dataKey.
  public static selectPage<T>(selection: T[], page: T[]): T[] {
    const pageIds = new Set(page.map(TableSelectionBarComponent.rowId));

    return [
      ...selection.filter(
        (row) => !pageIds.has(TableSelectionBarComponent.rowId(row)),
      ),
      ...page,
    ];
  }

  private static rowId(row: unknown): unknown {
    return (row as { id?: unknown }).id;
  }
}
